import { render, staticRenderFns } from "./ConfirmationBox.vue?vue&type=template&id=33a540f8&scoped=true"
import script from "./ConfirmationBox.vue?vue&type=script&lang=js"
export * from "./ConfirmationBox.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationBox.vue?vue&type=style&index=0&id=33a540f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a540f8",
  null
  
)

export default component.exports